import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/use-i18n'

const Pricing: React.FC = () => {
  const { t } = useTranslation()
  const included = [
    t('landing.pricing.included.aiMenus'),
    t('landing.pricing.included.costTracking'),
    t('landing.pricing.included.realTimeUpdates'),
    t('landing.pricing.included.multipleRestaurants'),
    t('landing.pricing.included.customDishes'),
  ]

  return (
    <div className="min-h-screen">
      <section className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-2xl sm:text-3xl lg:text-5xl xl:text-6xl font-bold mb-4 sm:mb-6 text-white leading-tight">
            {t('landing.pricing.title').replace(t('landing.pricing.titleHighlight'), '')}<span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">{t('landing.pricing.titleHighlight')}</span>
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto mb-8">
            {t('landing.pricing.subtitle')}
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-16">
          <div className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-8 sm:p-12 hover:border-white/20 transition-all duration-300">
            <div className="text-center mb-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">{t('landing.pricing.plan.title')}</h2>
              <p className="text-white/70">{t('landing.pricing.plan.description')}</p>
              <div className="mt-6">
                <span className="text-4xl sm:text-5xl font-bold text-white">{t('landing.pricing.plan.price')}</span>
                <span className="text-white/60 ml-2">{t('landing.pricing.plan.perMonth')}</span>
              </div>
            </div>
            <ul className="space-y-4 mb-8">
              {included.map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white/90">
                  <svg className="w-5 h-5 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/signup"
                className="inline-flex justify-center px-8 py-4 rounded-full bg-black hover:bg-black/80 text-white font-semibold transition-all duration-300"
              >
                {t('common.startForFree')}
              </Link>
              <Link
                to="/product"
                className="inline-flex justify-center px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-all duration-300"
              >
                {t('common.seeProduct')}
              </Link>
            </div>
          </div>
        </div>

        <div className="text-center bg-[#1a1a1a] rounded-2xl p-8 sm:p-12 border border-white/10 max-w-3xl mx-auto">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">{t('landing.pricing.enterprise.title')}</h3>
          <p className="text-white/70 mb-6">
            {t('landing.pricing.enterprise.body')}
          </p>
          <a
            href="mailto:contact@restoside.com"
            className="inline-flex justify-center px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-all duration-300"
          >
            {t('common.contactSales')}
          </a>
        </div>
      </section>
    </div>
  )
}

export default Pricing
